import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitInputsNumber.module.scss';

const NumberInput = ({
  id = '',
  className = '',
  value = '',
  onChange = () => {},
  isDisabled = false,
  testId = '',
  inputTestId = '',
  minValue = null,
  maxValue = null,
  shouldPreventScrollableChanges = false,
  placeholder = '',
  name = '',
  ariaLabel = '',
  isRequired = false,
  isReadOnly = false,
  isError = false,
  step = 1,
}) => {
  if (shouldPreventScrollableChanges) {
    useEffect(() => {
      const numberInput = document.getElementById(id);

      const preventMouseWheel = (e) => {
        e.preventDefault();
      };

      if (numberInput) {
        numberInput.addEventListener('wheel', preventMouseWheel);
      }

      return () => {
        if (numberInput) {
          numberInput.removeEventListener('wheel', preventMouseWheel);
        }
      };
    }, [id]);
  }

  return (
    <div
      className={classnames(styles.element, { [styles.isError]: isError }, className)}
      data-testid={testId}
    >
      <input
        id={id}
        data-testid={inputTestId}
        type="number"
        value={value}
        onChange={(event) => onChange(event.target.valueAsNumber)}
        min={minValue}
        max={maxValue}
        disabled={isDisabled}
        placeholder={placeholder}
        name={name}
        aria-label={ariaLabel}
        required={isRequired && !isReadOnly && !isDisabled}
        readOnly={isReadOnly}
        step={step}
      />
    </div>
  );
};

NumberInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  testId: PropTypes.string,
  inputTestId: PropTypes.string,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  shouldPreventScrollableChanges: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  isRequired: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isError: PropTypes.bool,
  step: PropTypes.number,
};

export { NumberInput as NumberInputStorybook };
export default React.memo(NumberInput);
